export const listTypeVehiclesService = (fetch) => async () => {
  try {
    const response = await fetch({
      url: "/api/v2/listar/vehiculos_compania",
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
